import React, { Component } from 'react';
import LayoutContentWrapper from '../../../components/utility/layoutWrapper';
import LayoutContent from '../../../components/utility/layoutContent';
//import Card from './uielements/card/card.style';
import { Col, Icon, Item, Radio, Row } from 'antd';
import ShowMore from 'react-show-more';
import "./help.css";
import { Tabs } from 'antd';
import PageHeader from '../../../components/utility/pageHeader';
import Header from "../header/index";
const TabPane = Tabs.TabPane;


export default class extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            selectedGroup: "homework",
        });
    }

    onAppChange = (e) => {
        this.setState({
            selectedGroup: e.target.value,
        })
    };
    render() {
        return (
            <div>
                <Header {...this.props} />
                <LayoutContentWrapper>
                    <div className="back_icon" onClick={() => this.props.history.goBack()}>
                        <i className="ion-ios-arrow-back"></i> Back
                    </div>
                    <LayoutContent className="layout">

                        <Tabs defaultActiveKey="1"
                            animated={false}
                            size="large"
                            tabBarGutter={50}
                        >
                            <TabPane tab={<span><div> <i className="ion-android-lock" /></div><div>Access & Invitations</div></span>} key="1">
                                <div className="TabItemRow">
                                    <PageHeader style={{ margin: "10px" }}>
                                        Login setup and invite clients
                                    </PageHeader>
                                    <Row gutter={16}>
                                        <Col md={12} >
                                            <div className="help-item">
                                                <div className="help-item_video-box">
                                                    <iframe id="video"
                                                        src="https://www.youtube.com/embed/sg32fFAFvYw?rel=0"
                                                        className="help-item_video"
                                                        frameBorder="0"
                                                    >
                                                    </iframe>
                                                </div>
                                                <h2 className="help-item_title">
                                                    ACCESS TO SWASTH FOR CLINICIANS
                                    </h2>

                                                <div className="help-item_description">
                                                    <ShowMore
                                                        lines={3}
                                                        more='Show more'
                                                        less='Show less'
                                                        anchorClass=''
                                                    >
                                                        <strong>Sign up</strong>
                                                        <p>The first step of provider onboarding is signup. If you already signed up for one of our client facing apps,use a different email than what you signed up there with.
                                            </p>
                                                        <p><strong>Account Confirmation</strong></p>
                                                        <p>Once you sign up and verify email, we will verify your credentials and confirm your account. You will receive an email about the account being confirmed and then you can login.
                                            </p>
                                                        <p><strong>MFA Setup</strong></p>
                                                        <p>The very first time, you login you will have to Set up Two-Factor Authentication (Multifactor Authentication). You will have to download Google Authenticator from
                                            <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"> Playstore</a> or
                                            <a href="https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8"> App Store</a> onto your mobile device. Then you need to set up Google authenticator. You can refer this
                                            <a href="https://support.google.com/accounts/answer/1066447?co=GENIE.Platform%3DiOS&hl=en"> guide</a>.
                                                                        Once you set up authenticator to sync with your account, every time you login you will be asked for MFA code and you will enter the code from the authenticator app.
                                    </p>
                                                    </ShowMore>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={12} >
                                            <div className="help-item">
                                                <div className="help-item_video-box">
                                                    <iframe id="video"
                                                        src="https://www.youtube.com/embed/a0YGEOZL-fE?rel=0"
                                                        className="help-item_video"
                                                        frameBorder="0"
                                                    >
                                                    </iframe>
                                                </div>
                                                <h2 className="help-item_title">
                                                    INVITE CLIENTS TO SHARE DATA
                                    </h2>

                                                <div className="help-item_description">
                                                    <ShowMore
                                                        lines={3}
                                                        more='Show more'
                                                        less='Show less'
                                                        anchorClass=''
                                                    >
                                                        <strong>Add clients</strong>
                                                        <p>On the left navigation, click on Clients menu and add a client. Make sure you set the client to 'Active' using the toggle button.</p>
                                                        <strong>Invite clients</strong>
                                                        <p>Navigate to the DBT Daily App, on the left navigation bar (under apps). Then click on the "Invite Clients" button. Then from the list of clients in the dropdown box select the client to invite and click "Send". </p>
                                                        <strong>Client sharing settings</strong>
                                                        <p>Your client/s will receive an email with a confirmation code and provider email address. On their DBT Daily App, they will navigate to "Sharing Settings" screen using the left navigation bar (Settings > Sharing Settings). They will need
                                                            to then click the '+' button and in the next screen enter the confirmation code and email address that they received in the email and click 'Submit' button. On the next screen
                                            they will check one more more diary card items that they want to share with you and click "Save".</p>

                                                        <strong>View client data</strong>

                                                        <p>Once the client has set their sharing settings, you can login to the clinician app and navigate to the corresponding app eg. DBT Daily app where you can see the client's name added to the list.
                                                            When you click on the clien't name, you can see his/her diary data (entries and statistics).
                                            </p>
                                                    </ShowMore>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <PageHeader style={{ margin: "10px" }}>
                                        Lost MFA?
                        </PageHeader>

                                </div>
                            </TabPane>
                            <TabPane tab={<span><div><i className="ion-android-calendar" /></div><div>Entries & Stats</div></span>} key="4">
                                <div className="TabItemRow">
                                    <PageHeader style={{ margin: "10px" }}>

                                    </PageHeader>
                                    <Row gutter={16}>
                                        <Col md={12} >
                                            <div className="help-item">
                                                <div className="help-item_video-box">
                                                    <iframe id="video"
                                                        src="https://www.youtube.com/embed/O99CHCfcGN4?rel=0"
                                                        className="help-item_video"
                                                        frameBorder="0"
                                                    >
                                                    </iframe>
                                                </div>
                                                <h2 className="help-item_title">
                                                    ENTRY DATA
                                    </h2>

                                                <div className="help-item_description">
                                                    <ShowMore
                                                        lines={3}
                                                        more='Show more'
                                                        less='Show less'
                                                        anchorClass=''
                                                    >
                                                        <p>To access entries’ screen, click on ‘Apps’ on the left navigation menu and pick the app that your client uses. Click the client name and you will see different tabs such as Entries, Exercises, Practice Ideas, Statistics etc. based on the app.
                                            </p>
                                                        <p>
                                                            This gives a holistic view of your client and you can even click on an individual exercise to see the answers to question on each exercise (as long as your client has chosen to share exercise data with you).
                                            </p>
                                                        <p>The statistic tab gives an overall summary for the selected period such as mood chart, most common skills, behaviors, etc.
                                            </p>
                                                        <p>Being able to see data at a very detailed level as well as summary helps you to see what is working or not and tailor your approach accordingly.
                                            </p>
                                                    </ShowMore>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </TabPane>
                            <TabPane tab={<span><div><i className="ion-ios-book" /></div><div>Homework</div></span>} key="3">
                                <div className="TabItemRow">
                                    <PageHeader style={{ margin: "10px" }}>

                                    </PageHeader>
                                    <Row gutter={16}>
                                        <Col md={12} >
                                            <div className="help-item">
                                                <div className="help-item_video-box">
                                                    <iframe id="video"
                                                        src="https://www.youtube.com/embed/T0AnA0Z8En4?rel=0"
                                                        className="help-item_video"
                                                        frameBorder="0"
                                                    >
                                                    </iframe>
                                                </div>
                                                <h2 className="help-item_title">
                                                    HOMEWORK
                            </h2>

                                                <div className="help-item_description">
                                                    <ShowMore
                                                        lines={3}
                                                        more='Show more'
                                                        less='Show less'
                                                        anchorClass=''
                                                    >
                                                        <strong>Assign Homework</strong><p></p>
                                                        <p>
                                                            Homework can be assigned to an individual client or a group. To assign homework, expand the homework menu on the left menu and click on ‘Schedule’. Then select an app and choose a type or category (Exercise, Lesson etc) which should bring a list of items for the corresponding type. Select one or more items, which should add them to a list on the right. Choose another type and do the same. You can also search for items by clicking the search icon against next to Module or Title.
                                    </p>
                                                        <p><strong>View Clients' Homework</strong></p>
                                                        <p> Once you have selected all items that you want to assign to this homework, click on ‘Assign’ button. Then in the popup, add a title for the homework, select due date and the select Group or Client to assign to. Select the group / clients you want to assign to and click submit.
                                    </p>
                                                        <p>Now if you navigate to the ‘List” Submenu on the left nav, you can see the homework under the corresponding app.
                                    </p>
                                                    </ShowMore>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={12} >
                                            <div className="help-item">
                                                <div className="help-item_video-box">
                                                    <iframe id="video"
                                                        src="https://www.youtube.com/embed/QJlWhKNc5oc?rel=0"
                                                        className="help-item_video"
                                                        frameBorder="0"
                                                    >
                                                    </iframe>
                                                </div>
                                                <h2 className="help-item_title">
                                                    GROUPS
                            </h2>

                                                <div className="help-item_description">
                                                    <ShowMore
                                                        lines={3}
                                                        more='Show more'
                                                        less='Show less'
                                                        anchorClass=''
                                                    >
                                                        <p>You can create a group if you do group therapy or a skills training group (like for eg. DBT skills training).
                                </p>
                                                        <p>By creating a group, you can assign homework to the entire group  instead of individually assigning homework to individual clients.
                                </p>
                                                        <p>Also we will enable messaging between members in the group in the near future (which they can opt-in or not).
                                </p>
                                                        <p>To create a group, click on Groups on the left navigation and click the “Add Group”
                                </p>

                                                    </ShowMore>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                </div>
                            </TabPane>
                            <TabPane tab={<span><div><i className="ion-android-clipboard" /></div><div>Assessments</div></span>} key="2">
                                <div className="TabItemRow">
                                    <PageHeader style={{ margin: "10px" }}>

                                    </PageHeader>
                                    <Row gutter={16}>
                                        <Col md={12} >
                                            <div className="help-item">
                                                <div className="help-item_video-box">
                                                    <iframe id="video"
                                                        src="https://www.youtube.com/embed/oAbcj8dQYUw?rel=0"
                                                        className="help-item_video"
                                                        frameBorder="0"
                                                    >
                                                    </iframe>
                                                </div>
                                                <h2 className="help-item_title">
                                                    ASSESSMENTS
                                    </h2>

                                                <div className="help-item_description">
                                                    <ShowMore
                                                        lines={3}
                                                        more='Show more'
                                                        less='Show less'
                                                        anchorClass=''
                                                    >
                                                        <p>You can use standardized clinical assessments such as PHQ-9, GAD-7 etc. to track how your clients are doing and adjust treatment accordingly.
                                            </p>
                                                        <strong>Assign Assessments</strong><p></p>
                                                        <p>
                                                            To assign assessments, expand “Assessments” on the left nav and and click on ‘Schedule. Then pick an assessment and click “Assign Client” button. In the popup, select a client, the start date and how often and then click submit. It will show up in the list of scheduled clients for that assessment.
                                            </p>
                                                        <p><strong>View Clients' Results</strong></p>
                                                        <p> Once your client has taken the assessment, the results will show up in the Results submenu. The graph indicates how the client scored each time they took the assessment.
                                            </p>
                                                    </ShowMore>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                </div>

                            </TabPane>



                        </Tabs>

                    </LayoutContent>
                </LayoutContentWrapper>
            </div>
        );
    }
}
